import {
  Avatar,
  Button,
  Flex,
  Icon,
  Input,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import React, { useMemo } from "react";
import { FaEdit } from "react-icons/fa";
import {
  TiArrowSortedDown,
  TiArrowSortedUp,
  TiArrowUnsorted,
} from "react-icons/ti";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";

function DriversTable({ columnsData, tableData, onEdit }) {
  const columns = useMemo(
    () => [
      ...columnsData,
      {
        Header: "Action",
        accessor: "action",
        Cell: ({ row }) => (
          <Flex gap={3}>
            <Icon
              as={FaEdit}
              color="blue.500"
              cursor="pointer"
                w="20px"
                h="20px"
              onClick={() => onEdit(row.original)}
            />
          </Flex>
        ),
      },
    ],
    [columnsData, onEdit]
  );

  const data = useMemo(() => tableData, [tableData]);

  const tableInstance = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    setGlobalFilter,
    state,
  } = tableInstance;

  const { globalFilter } = state;

  return (
    <Flex direction="column" w="100%" overflowX="auto">
      <Flex align={{ sm: "flex-start", lg: "flex-end" }}
        justify={{ sm: "flex-start", lg: "flex-end" }}
        w="100%"
        px="22px"
        mb="36px">
        <Input
          type="text"
          placeholder="Search..."
          minW="75px"
          maxW="175px"
          fontSize="sm"
          _focus={{ borderColor: "teal.300" }}
          onChange={(e) => setGlobalFilter(e.target.value)}
        />
      </Flex>
      <Flex direction="column" overflowX="auto" overflowY="auto" maxH="400px">
        <Table {...getTableProps()} variant="simple" color="gray.500" mb="24px">
          <Thead position="sticky" top="0" zIndex="1" bg="white">
            {headerGroups.map((headerGroup, index) => (
              <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
                {headerGroup.headers.map((column, index) => (
                  <Th {...column.getHeaderProps(column.getSortByToggleProps())} key={index}>
                    <Flex justify="space-between" align="center" fontSize="12px" color="gray.400">
                      {column.render("Header")}
                      <Icon
                        w="14px"
                        h="14px"
                        color={column.isSorted ? "gray.500" : "gray.400"}
                        as={
                          column.isSorted
                            ? column.isSortedDesc
                              ? TiArrowSortedDown
                              : TiArrowSortedUp
                            : TiArrowUnsorted
                        }
                      />
                    </Flex>
                  </Th>
                ))}
              </Tr>
            ))}
          </Thead>
          <Tbody {...getTableBodyProps()}>
            {page.map((row, index) => {
              prepareRow(row);
              return (
                <Tr {...row.getRowProps()} key={index}>
                  {row.cells.map((cell, index) => (
                    <Td {...cell.getCellProps()} key={index} fontSize="14px" minW="150px">
                      {cell.render("Cell")}
                    </Td>
                  ))}
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </Flex>
    </Flex>
  );
}

export default DriversTable;
